import { useQuery } from 'react-query';
import toastr from 'react-hot-toast';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { CACHE_AND_STALE_TIME } from 'constants/index';
import {
  generateIncludeQuery,
  generateURL,
} from 'utilities/hooks/urlGeneration';
import { fetchWrapper } from 'utils/fetchWrapper';
import { SingleSparkRunResponse } from 'types/SparkRun';
import { filterIncludedItem } from 'utilities/hooks/responseHandlers';
import { SparkTask } from 'types/SparkTasks';
import { Spark } from 'types/Spark/Spark';

const getSparkRunByID = (runID: string | undefined) => {
  if (!runID) {
    Promise.reject('Spark Run ID cannot be null');
    return;
  }
  const queryArray = [generateIncludeQuery(['sparkTasks','spark'])];
  const url = generateURL(SPARK_RESOURCE_TYPES.SPARK_RUN, queryArray, runID);
  return fetchWrapper<SingleSparkRunResponse>({
    url: url,
    method: 'GET',
  });
};

export const useSparkRunByID = (
  runID: string | undefined,
  enabled: boolean = true
) => {
  const response = useQuery(['SparkRun', runID], () => getSparkRunByID(runID), {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`Failed to fetch Spark Run: ${error.message}`);
      }
    },
    enabled: Boolean(runID && enabled),
    ...CACHE_AND_STALE_TIME,
  });
  const { data } = response;
  const { data: sparkRun, included } = data || {};
  const sparkTasks = filterIncludedItem<SparkTask>(
    included,
    SPARK_RESOURCE_TYPES.SPARK_TASKS
  );
  const spark = included?.find((item) => item.type === SPARK_RESOURCE_TYPES.SPARKS) as Spark|undefined

  return {
    ...response,
    spark,
    sparkTasks,
    sparkRun,
  };
};
